<div class="width-1100">

    <mat-card id='table-header'>
        <mat-toolbar class="toolbar-top">
            <div class='title'>
                <mat-icon>local_atm</mat-icon>
                <div>Vouchers</div>
            </div>
        </mat-toolbar>
    </mat-card>

    <mat-card>
        <mat-form-field class="half-width" appearance="outline">
            <mat-label>Patrocinadores</mat-label>
            <mat-select (ngModelChange)='sponsorSelected($event)' [formControl]="entityForm.controls.sponsor_id"
                [errorStateMatcher]="matcher">
                <mat-option *ngFor="let sponsor of sponsors" [value]="sponsor.id">
                    {{ sponsor.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="half-width" appearance="outline">
            <mat-label>Produtos</mat-label>
            <mat-select (ngModelChange)='productSelected($event)' [formControl]="entityForm.controls.product_id"
                [errorStateMatcher]="matcher">
                <mat-option *ngFor="let product of products" [value]="product.id">
                    {{ product.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

    </mat-card>


    <mat-tab-group>

        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class='tab-icon'>local_atm</mat-icon>
                <div>Consultar</div>
            </ng-template>

            <div class='tab-content'>

                <mat-table [dataSource]="voucherDataSource" matSort matSortDisableClear='true'
                    style='height: 280px; overflow: auto;'>

                    <!-- Icon Column -->
                    <ng-container matColumnDef="icon" class='mural-name'>
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <mat-icon style='font-size:1.2em; margin-top:10px;'>local_atm</mat-icon>
                        </mat-cell>
                    </ng-container>

                    <!-- name Column -->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Voucher </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
                    </ng-container>

                    <!-- discount Column -->
                    <ng-container matColumnDef="discount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Valor </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.discount | currency:'R$ ':true }} </mat-cell>
                    </ng-container>

                    <!-- Member Column -->
                    <ng-container matColumnDef="member">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Usuário</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span *ngIf='element.member_name'>
                                {{ element.member_name }}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span *ngIf='element.member_name'>
                                {{ element.member_email }}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <!-- Sent Column -->
                    <ng-container matColumnDef="sent">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Enviado </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span *ngIf='element.date_sent'>
                                {{ element.date_sent | date: 'dd/MM/yyyy' }}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <!-- Used Column -->
                    <ng-container matColumnDef="used">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Usado </mat-header-cell>
                        <mat-cell *matCellDef="let element">

                            <span *ngIf='element.used'>
                                <img src='/assets/images/status/img_blue.png'>
                            </span>

                            <span *ngIf='!element.used'>
                                <img src='/assets/images/status/img_silver.png'>
                            </span>

                        </mat-cell>
                    </ng-container>


                    <!-- edit Column -->
                    <ng-container matColumnDef="edit">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
                                <mat-icon class='icon-info'>
                                    info_outline
                                </mat-icon>
                            </a>
                        </mat-cell>
                    </ng-container>


                    <!-- delete Column -->
                    <ng-container matColumnDef="delete">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <a mat-button (click)='delete(element)' style='background-color: whitesmoke;'>
                                <mat-icon class='icon-delete'>delete_outline
                                </mat-icon>
                            </a>
                        </mat-cell>
                    </ng-container>

                    <!-- Header -->
                    <mat-header-row *matHeaderRowDef="displayedVoucherColumns"></mat-header-row>

                    <!-- Row -->
                    <mat-row *matRowDef="let row; columns: displayedVoucherColumns;"></mat-row>

                </mat-table>

            </div>

        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class='tab-icon'>local_atm</mat-icon>
                <div>Criar</div>
            </ng-template>

            <div class='tab-content'>
                <mat-form-field class="number-width" appearance="outline">
                  <mat-label>Quantidade</mat-label>
                    <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.qty"
                        autocomplete="off">
                    <mat-error *ngIf="entityForm.controls.qty.hasError('required')">
                        A quantidade é obrigatória
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="number-width" appearance="outline">
                  <mat-label>Valor</mat-label>
                    <input matInput type="number" [errorStateMatcher]="matcher"
                        [formControl]="entityForm.controls.discount" autocomplete="off">
                    <mat-error *ngIf="entityForm.controls.discount.hasError('required')">
                        O valor é obrigatório
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="number-width"appearance="outline">
                  <mat-label>Chave</mat-label>
                    <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
                         autocomplete="off">
                    <mat-error *ngIf="entityForm.controls.name.hasError('required')">
                        O Nome é obrigatório
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="number-width" appearance="outline">
                  <mat-label>Início</mat-label>
                    <input matInput type="number" [errorStateMatcher]="matcher"
                        [formControl]="entityForm.controls.start" autocomplete="off">
                </mat-form-field>

                <button mat-raised-button (click)='createVouchers()' [disabled]="entityForm.invalid">
                    <mat-icon class='icon-add'>add_circle_outline</mat-icon>
                </button>


                <mat-table [dataSource]="dataSource" matSort matSortDisableClear='true'
                    style='height: 180px; overflow: auto;'>

                    <!-- Icon Column -->
                    <ng-container matColumnDef="icon" class='mural-name'>
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <mat-icon style='font-size:1.2em; margin-top:10px;'>local_atm</mat-icon>
                        </mat-cell>
                    </ng-container>

                    <!-- name Column -->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Voucher </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
                    </ng-container>

                    <!-- discount Column -->
                    <ng-container matColumnDef="discount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Valor </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.discount }} </mat-cell>
                    </ng-container>

                    <!-- sponsor Column -->
                    <ng-container matColumnDef="sponsor">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Patrocínio </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{ element.sponsor_name }}
                        </mat-cell>
                    </ng-container>

                    <!-- product Column -->
                    <ng-container matColumnDef="product">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Produto </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{ element.product_name }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <a mat-button (click)='delete(element)' style='background-color: whitesmoke;'>
                                <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                                </mat-icon>
                            </a>
                        </mat-cell>
                    </ng-container> 

                    <!-- Header -->
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                    <!-- Row -->
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

                </mat-table>

            </div>

            <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
                <div [ngClass]="{hidden: !spinner}">
                    <mat-spinner diameter="30"></mat-spinner>
                </div>
                <button mat-raised-button (click)='registerVouchers()' [disabled]="!hasList">
                    <mat-icon class='icon-done'>check_circle_outline</mat-icon>
                </button>
            </div>


        </mat-tab>

    </mat-tab-group>

</div>
